import styled from 'styled-components/macro';
import { ToastContainer } from 'react-toastify';

export const StyledToast = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    z-index: 50001;
  }
  .Toastify__toast--info {
    background-color: ${({ theme }) => theme.colors.info};
  }
  .Toastify__toast--success {
    background-color: ${({ theme }) => theme.colors.severity0};
  }
  .Toastify__toast--error {
    background-color: ${({ theme }) => theme.colors.severity2};
  }
`;
